export default {
    users: [],
    lists: {}
}